import { render, staticRenderFns } from "./MobileHeaderMenu.vue?vue&type=template&id=e97e38a8&scoped=true&"
import script from "./MobileHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeaderMenu.vue?vue&type=style&index=0&id=e97e38a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97e38a8",
  null
  
)

export default component.exports